import { useEffect, useState, useCallback, useContext } from 'react';
import Cookies from 'js-cookie';
import Table from '@components/Table';

import BackgroundDark from '@assets/login-background.jpg';
import BackgroundLight from '@assets/background-light.jpg';
import { Cancel } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { ISCOArchetypeContext } from '@providers/ISCOArchetype';

import './laborForcast.scss';

const LaborForecast: React.FC = () => {
  const [darkMode] = useState<boolean>(Cookies.get('darkMode') === 'true');
  const {
    setIsISCOPopupShown,
    isLaborForcastPopupShown,
    setIsLaborForcastPopupShown,
  } = useContext(ISCOArchetypeContext);

  const [disappearingSkills, setDisappearingSkills] = useState<any>([]);
  const [growthInTopSkills, setGrowthInTopSkills] = useState<any>([]);
  /*const [elementaryOccupations, setElementaryOccupations] = useState<any>([]);*/
  const [topGrowingSkills, setTopGrowingSkills] = useState<any>([]);
  const [growthElementaryOccupations, setGrowthElementaryOccupations] =
    useState<any>([]);
  const [demandedSkills, setDemandedSkills] = useState<any>([]);
  const [demandSkillsInOccupation, setDemandSkillsInOccupation] = useState<any>(
    [],
  );
  const navigate = useNavigate();

  // const topOccupationsDataColumn = [
  //   { key: 'occupation', label: 'Top 10 Occupation' },
  //   { key: '2024', label: '2024' },
  //   { key: '2025', label: '2025' },
  //   { key: '2026', label: '2026' },
  //   { key: 'growthRate22_23', label: "growth Rate" }
  // ]

  // const topSectorsDataColumn = [
  //   { key: 'sector', label: 'Top 10 Sector' },
  //   { key: '2024', label: '2024' },
  //   { key: '2025', label: '2025' },
  //   { key: '2026', label: '2026' },
  //   { key: 'growthRate22_23', label: "growth Rate" }
  // ]

// const topSkillsDataColumn = [
//    { key: 'skill', label: 'Top 10 Skill' },
//   { key: '2024', label: '2024' },
//    { key: '2025', label: '2025' },
//    { key: '2026', label: '2026' },
//   { key: 'growthRate22_23', label: "growth Rate" }
//  ]

const topOccupationsDataColumn = [
  { key: 'occupation', label: 'Top 10 Occupations' }
]

const topSectorsDataColumn = [
  { key: 'sector', label: 'Top 10 Sectors' }
]

 const topSkillsDataColumn = [
  { key: 'skill', label: 'Top 10 Skills in demand' }
]


  const totaljobpostColumn = [
    { key: 'totalJob', label: 'Total Jobs' },
    { key: 'Year', label: 'Year' },
    { key: 'Avrgrowthrate', label: 'Avr Growth Rate' },
  ]

  const topOccupationsData = [
    {
      occupation: "Data Entry Clerks",
      "2024": 37176,
      "2025": 610164,
      "2026": 10014645,
      growthRate22_23: "1541%",
    },
    {
      occupation: "Fire Fighters",
      "2024": 9979,
      "2025": 168510,
      "2026": 2845416,
      growthRate22_23: "1589%",
    },
    {
      occupation: "Petroleum and Natural Gas Refining Plant Operators",
      "2024": 5649,
      "2025": 117766,
      "2026": 2454975,
      growthRate22_23: "1985%",
    },
    {
      occupation: "Odd Job Persons",
      "2024": 1369,
      "2025": 50653,
      "2026": 1874161,
      growthRate22_23: "3600%",
    },
    {
      occupation: "Printers",
      "2024": 2704,
      "2025": 70304,
      "2026": 1827904,
      growthRate22_23: "2500%",
    },
    {
      occupation: "Computer Network and Systems Technicians",
      "2024": 10805,
      "2025": 123280,
      "2026": 1406584,
      growthRate22_23: "1041%",
    },
    {
      occupation: "Chemical Engineers",
      "2024": 7648,
      "2025": 87815,
      "2026": 1008354,
      growthRate22_23: "1048%",
    },
    {
      occupation: "Fumigators and Other Pest and Weed Controllers",
      "2024": 1201,
      "2025": 29412,
      "2026": 720600,
      growthRate22_23: "2350%",
    },
    {
      occupation: "Production Clerks",
      "2024": 5193,
      "2025": 56413,
      "2026": 612849,
      growthRate22_23: "986%",
    },
    {
      occupation: "Electrical Engineering Technicians",
      "2024": 1908,
      "2025": 34029,
      "2026": 606850,
      growthRate22_23: "1683%",
    },
  ];

  const topSectorsData = [
    {
      sector: "Administrative and support service activities",
      "2024": 141235,
      "2025": 870950,
      "2026": 5370860,
      growthRate22_23: "517%",
    },
    {
      sector: "Manufacturing",
      "2024": 107062,
      "2025": 323061,
      "2026": 974842,
      growthRate22_23: "202%",
    },
    {
      sector: "Real estate activities",
      "2024": 5641,
      "2025": 30657,
      "2026": 166605,
      growthRate22_23: "443%",
    },
    {
      sector: "Professional, scientific and technical activities",
      "2024": 20723,
      "2025": 34224,
      "2026": 56520,
      growthRate22_23: "65%",
    },
    {
      sector: "Transportation and storage",
      "2024": 6217,
      "2025": 18473,
      "2026": 54894,
      growthRate22_23: "197%",
    },
    {
      sector: "Accommodation and food service activities",
      "2024": 11462,
      "2025": 24402,
      "2026": 51949,
      growthRate22_23: "113%",
    },
    {
      sector: "Mining and quarrying",
      "2024": 7226,
      "2025": 15300,
      "2026": 32393,
      growthRate22_23: "112%",
    },
    {
      sector: "Electricity, gas, steam and air conditioning supply",
      "2024": 1135,
      "2025": 5700,
      "2026": 28628,
      growthRate22_23: "402%",
    },
    {
      sector: "Information and communication",
      "2024": 20334,
      "2025": 22979,
      "2026": 25968,
      growthRate22_23: "13%",
    },
    {
      sector: "Wholesale and retail trade; repair of motor vehicles and motorcycles",
      "2024": 13837,
      "2025": 18607,
      "2026": 25023,
      growthRate22_23: "34%",
    },
  ];
  

  const topSkillsData = [
    {
      skill: "Color Theory",
      "2024": 4225,
      "2025": 274625,
      "2026": 17850625,
      growthRate22_23: "6400%",
    },
    {
      skill: "Drainage Systems",
      "2024": 3969,
      "2025": 250047,
      "2026": 15752961,
      growthRate22_23: "6200%",
    },
    {
      skill: "Process Safety",
      "2024": 4901,
      "2025": 242575,
      "2026": 12007450,
      growthRate22_23: "4850%",
    },
    {
      skill: "Plumbing Codes",
      "2024": 3136,
      "2025": 175616,
      "2026": 9834496,
      growthRate22_23: "5500%",
    },
    {
      skill: "Energy Supply",
      "2024": 4232,
      "2025": 194672,
      "2026": 8954912,
      growthRate22_23: "4500%",
    },
    {
      skill: "KVM Switch",
      "2024": 2704,
      "2025": 140608,
      "2026": 7311616,
      growthRate22_23: "5100%",
    },
    {
      skill: "Integrated Services",
      "2024": 4485,
      "2025": 173433,
      "2026": 6706072,
      growthRate22_23: "3767%",
    },
    {
      skill: "Garbage Disposal Unit",
      "2024": 2025,
      "2025": 91125,
      "2026": 4100625,
      growthRate22_23: "4400%",
    },
    {
      skill: "Azure Security",
      "2024": 2738,
      "2025": 101306,
      "2026": 3748322,
      growthRate22_23: "3600%",
    },
    {
      skill: "Drilling Rig",
      "2024": 1849,
      "2025": 79507,
      "2026": 3418801,
      growthRate22_23: "4200%",
    },
  ];

  const totaljobpost = [
    {
        totalJob: "162591",
        Year: "2026",
        Avrgrowthrate: "14%",
      }
  ]
  

  const handleCloseLaborForcastPopup = useCallback(() => {
    setIsISCOPopupShown && setIsISCOPopupShown(false);
    setIsLaborForcastPopupShown && setIsLaborForcastPopupShown(false);
  }, [setIsLaborForcastPopupShown, setIsISCOPopupShown]);

  return (
    <div className="laborForcast-details">


    <div className="graph">
    <div className="graph__headerSection">
        
          <div className="graph__closeSection">
            <Cancel
              type="button"
              onClick={handleCloseLaborForcastPopup}
              className="graph__close-button"
            />
          </div>
        </div>
      <div className="graph__content" style={{ maxWidth: "1400px", margin: "0 auto", padding: "5px" }}>
     
  
        <div className="mb-3">
          <div className="row">
            <div className="col-4 mb-3">
            <div>
            <h2 className="graph__title" style={{ textAlign: "left" }}>Labour Forecast</h2>
            <hr></hr>
          </div>
              <div style={{ marginBottom: 10 }}>
                <div>
                  <div className="total-job-post-number-container" style={{ textAlign: "center" }}>
                    <div className="total-job-post-number">
                    <h3 style={{ fontSize: "1.2rem", marginTop: "25px" }}>Total job posts growth for 2026</h3>
                      <div className="d-flex total-job-post align-items-center justify-content-center">
                        <h1 style={{ fontSize: "2.5rem", fontWeight: "bold", color: "#fff" }}>162 591</h1>
                        <span style={{ marginLeft: "8px", fontSize: "1.5rem", color: "green" }}>▲</span>
                      </div>
                  
                    </div>
                    <div className="total-job-post-number historic-numbers">
                    <h3 style={{ fontSize: "1rem", marginTop: "25px" }}>Average Growth</h3>
                      <div className="d-flex total-job-post align-items-center justify-content-center">
                        <h1 style={{ fontSize: "2rem", fontWeight: "bold", color: "#2b7a78" }}>14%</h1>
                      </div>
                    
                    </div>
                  </div>
                </div>
              </div>
            </div>
  
            <div className="col-8 mb-3">
              <div className="widget-component" style={{ marginBottom: 0 }}>
               
                <div>
                  <Table
                    id="topJobpost"
                    columns={topOccupationsDataColumn}
                    data={topOccupationsData}
                  
                  />
                </div>
              </div>
            </div>
          </div>
  
          <div className="row">
            <div className="col-6 mb-3">
              <div className="widget-component" style={{ marginBottom: 0 }}>
               
                <div>
                  <Table
                    id="topJobpost"
                    columns={topSectorsDataColumn}
                    data={topSectorsData}
             
                  />
                </div>
              </div>
            </div>
  
            <div className="col-6 mb-3">
              <div className="widget-component" style={{ marginBottom: 0 }}>
               
                <div>
                  <Table
                    id="topJobpost"
                    columns={topSkillsDataColumn}
                    data={topSkillsData}
               
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <div
        className="graph__background"
        style={{
          backgroundImage: `url(${darkMode ? BackgroundDark : BackgroundLight})`,
        }}
      />
    </div>
  </div>
  
  );
};

export default LaborForecast;
